export default "__VITE_ASSET__BzW45V0M__"